import { gettext } from '@eventbrite/legacy-infra.i18n';
import React from 'react';
import { computeRegulationLabel } from '../../../util';
import { RadioInput } from './RadioInput';
import styles from './ReportEventFormRadios.module.scss';

const radioClassNames = styles.radioInput;

export const ReportEventFormRadios = (props: {
    country: string;
    userCountry: string;
}) => {
    const { country, userCountry } = props;
    const regulationLabel = computeRegulationLabel(country, userCountry);
    const showOtherIllegalContent = regulationLabel !== '';
    const radioInputRender = showOtherIllegalContent && (
        <RadioInput
            reason="reason_other_illegal_eu_dsa"
            containerClassNames={radioClassNames}
        >
            {gettext('Other Illegal Content')}
        </RadioInput>
    );
    return (
        <div className={styles.radioContainer}>
            <RadioInput
                reason="reason_refund"
                containerClassNames={radioClassNames}
            >
                {gettext('Request a Refund')}
            </RadioInput>
            <RadioInput
                reason="reason_feedback"
                containerClassNames={radioClassNames}
            >
                {gettext('Ask a question or give feedback about the event')}
            </RadioInput>
            <RadioInput
                reason="reason_canceled_event"
                containerClassNames={radioClassNames}
            >
                {gettext('Event did not happen or was not as described')}
            </RadioInput>
            <RadioInput
                reason="reason_spam_behavior"
                containerClassNames={radioClassNames}
            >
                {gettext('Spam or misleading content')}
            </RadioInput>
            <RadioInput
                reason="reason_unauthorized_event"
                containerClassNames={radioClassNames}
            >
                {gettext(
                    'Event not authorised to sell tickets or report invalid tickets',
                )}
            </RadioInput>
            <RadioInput
                reason="reason_payment_outside"
                containerClassNames={radioClassNames}
            >
                {gettext('Payment required outside Eventbrite')}
            </RadioInput>
            <RadioInput
                reason="reason_harmful"
                containerClassNames={radioClassNames}
            >
                {gettext('Harmful Content')}
            </RadioInput>
            <RadioInput
                reason="reason_offensive_content"
                containerClassNames={radioClassNames}
            >
                {gettext('Regulated Content or Activities')}
            </RadioInput>
            <RadioInput
                reason="reason_explicit"
                containerClassNames={radioClassNames}
            >
                {gettext('Sexually Explicit Content')}
            </RadioInput>
            <RadioInput
                reason="reason_hateful"
                containerClassNames={radioClassNames}
            >
                {gettext('Hateful Content')}
            </RadioInput>
            <RadioInput
                reason="reason_extremism"
                containerClassNames={radioClassNames}
            >
                {gettext('Violence or Extremism')}
            </RadioInput>
            <RadioInput
                reason="reason_copyright_infringement"
                containerClassNames={radioClassNames}
            >
                {gettext('Copyright or Trademark Infringement')}
            </RadioInput>
            {radioInputRender}
        </div>
    );
};
